export default {
  inject: ['URL_TOURS'],
  data() {
    return {
      carregando: true,
      erroCarregamento: null,
    }
  },
  methods: {
    carregarRecurso({ url, chaveErro, onSuccess }) {
      this.carregando = true
      this.erroCarregamento = null
      this.$api.get(url)
        .then(({ data }) => onSuccess(data))
        .catch(() => {
          this.erroCarregamento = this.$i18n(`.${chaveErro}`)
        })
        .finally(() => {
          this.carregando = false
        })
    },
  },
  mounted() {
    this.carregar?.()
  },
}
